import React, { useState } from "react";
import "../../../../assets/scss/components/clientarea/serviceRequest/serviceRequest.scss";
import {
  createDdpiSR,
  DdpiValidation,
  getDdpiDetails,
  getDDPIPreFilledFormPDF,
} from "../../../service/serviceRequest/srApiService";
import { useHistory } from "react-router-dom";
import InputField from "../../../generic/inputField";
import TocDropdown from "../../../generic/tocDropdown";
import LoginService from "../../../service/login/loginService";
import urlConfig, { config } from "../../../../config/domain";
import { getEsignUrlJMWV2 } from "../../../service/esign/esignService";
import Checkbox from "../../../generic/checkbox";
import EdButton from "../../../generic/edButton";

export const Ddpi = (props: any) => {
  const [showTextStatus, setShowTextStatus] = useState(false);
  const [preFilledForm, setPreFilledForm] = React.useState<any>();
  const [ddpiId, setDdpiId] = React.useState("");
  const [ddpiDetails, setDdpiDetails] = React.useState([]);
  const [ddpiDetailsErrStatus, setDdpiDetailsErrStatus] = React.useState(false);
  const [ddpiDetailsErrMessage, setDdpiDetailsErrMessage] = React.useState("");
  const [singleDdpiId, setsingleDdpiId] = React.useState("");
  const [singleDdpiStatus, setSingleDdpiStatus] = React.useState(true);
  const [validationErr, setValidationErr] = React.useState<any>();
  const [validationErrStatus, setValidationErrStatus] = React.useState(false);
  const [ddpiIdOptions, setddpiIdOptions] = React.useState<any>([
    { value: "", display: "Select DDPID" },
  ]);
  const [prefillForm, setPreFillForm] = React.useState("");
  const [ddpiFlags, setDdpiFlags] = React.useState("SPMT");
  const [editSaveBtnStatus, setEditSaveBtnStatus] = useState(true);
  const history = useHistory();
  const [serviceReqListArr, setServiceReqListArr] = useState<any>();
  let storedList = window.sessionStorage.getItem("serviceReqList");
  React.useEffect(() => {
      setServiceReqListArr(storedList ? JSON.parse(storedList) : []);
  }, [storedList]);
  const RedirectnSource = window.localStorage.getItem("source");
  
  React.useEffect(() => {
    fetchDdpID();
    //getPreFilledFormPDF();
  }, []);

  React.useEffect(() => {
    props.rightDiv(rightSideDiv());
  }, [
    ddpiIdOptions,
    singleDdpiId,
    ddpiId,
    validationErr,
    ddpiDetails,
    singleDdpiStatus,
    preFilledForm,
  ]);

  /**
   * Add hypen with address when address is empty or address length is less than 5
   * @param address
   * @returns modifed address
   */
  const setAddressText = (address: string) => {
    if (!address || (address && address.length < 5)) {
      if (!address) {
        return "-".repeat(5);
      }
      const str = "-".repeat(5 - address.length);
      return `${address}${str}`;
    }
    return address;
  };

  /**
   * Redirect to clientArea/serviceRequest
   */
  function redirection() {
    window.location.href = RedirectnSource == "onep-sr" 
    ? config.onePlatformBase + "service-request" 
    : config.rootUrl + "clientarea/servicerequest";
  }

  /**
   * Convert Base 64 String into PDF
   * @param {Base64String } respData
   */
  function base64toPDF(respData: any) {
    var decodedPdfContent = atob(respData);
    var byteArray = new Uint8Array(decodedPdfContent.length);
    for (var i = 0; i < decodedPdfContent.length; i++) {
      byteArray[i] = decodedPdfContent.charCodeAt(i);
    }
    var blob = new Blob([byteArray.buffer], { type: "application/pdf" });
    var _pdfurl = URL.createObjectURL(blob);
    if (localStorage.getItem("lgnSrc") === "iphone") {
      window.open(_pdfurl, "_blank");
      props.setLoader(false);
    } else {
      var link = document.createElement("a");
      document.body.appendChild(link);
      link.href = _pdfurl;
      link.download = "file.pdf";
      var evt = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: false,
      });
      link.dispatchEvent(evt);
      window.URL.revokeObjectURL(_pdfurl);
      props.setLoader(false);
      redirection();
      link.remove();
    }
  }

  /**
   * Show Dropdown at rightSide Div
   */
  const rightSideDiv = () => {
    if (singleDdpiId || ddpiIdOptions.length > 1)
      return (
        <>
          <label className="input-label">DP Id</label>
          {singleDdpiStatus === true ? (
            <InputField
              type="text"
              className="ddpid_input"
              defaultValue={singleDdpiId ? singleDdpiId : ""}
              onChange={() => {}}
              onBlur={() => {}}
              disabled={true}
            />
          ) : (
            ddpiIdOptions && (
              <TocDropdown
                selectedValue={ddpiId ? ddpiId : ddpiIdOptions[0].value}
                dropdownOptions={ddpiIdOptions ? ddpiIdOptions : []}
                onSelect={(val: any) => {
                  setDdpiId(val);
                  validation(val);
                }}
                isSearchable={false}
              />
            )
          )}
          {validationErr ? (
            <p className="help_text red">{validationErr}</p>
          ) : (
            <></>
          )}
        </>
      );
    else return <></>;
  };

  /**
   * Get Dddpi Details
   */
  const fetchDdpID = async () => {
    props.setParLoader(true);
    try {
      const response = await getDdpiDetails();
      let jsonResponse = response;
      if (Object.keys(jsonResponse).length > 0) {
        if (jsonResponse.hasOwnProperty("data")) {
          const { DDPIDetails } = JSON.parse(jsonResponse.data.value).result[0];
          const ddpidData = DDPIDetails.find((val: any) => {
            if (val["defaultDemat"] === "Yes") {
              return val;
            }
            // return {};
          });
            
          if (ddpidData && Object.values(ddpidData).length !== 0) {
            setDdpiDetails(ddpidData);
            setsingleDdpiId(ddpidData.BOID);
            setDdpiId(ddpidData.BOID);
            setSingleDdpiStatus(true);
            validation(ddpidData.BOID);
          } else {
            openDDPIErrorPopup();
          }

          // if (DDPIDetails.length === 1) {
          //   setsingleDdpiId(DDPIDetails[0].BOID);
          //   setDdpiId(DDPIDetails[0].BOID);
          //   setSingleDdpiStatus(true);
          //   validation(DDPIDetails[0].BOID);
          // } else {
          //   const ddpiIdList = DDPIDetails.map((val: any) => {
          //     return { value: val.BOID, display: val.BOID };
          //   });
          //   setSingleDdpiStatus(false);
          //   setddpiIdOptions([...ddpiIdOptions, ...ddpiIdList]);
          //   setSingleDdpiStatus(false);
          // }
          props.setParLoader(false);
        } else if (jsonResponse.hasOwnProperty("error")) {
          const error = jsonResponse.error;
          if (error.errCd === "SR0021") {
            setDdpiDetailsErrStatus(true);
            setDdpiDetailsErrMessage(error.errMsg);
          } else {
            openDDPIErrorPopup();
          }
          props.setParLoader(false);
        }
      }
    } catch (error) {
      props.setParLoader(false);
      openDDPIErrorPopup();
    }
  };

  /**
   * Error Popup Only For Ddpi Component
   */
  const openDDPIErrorPopup = () => {
    props.setLoader(false);
    props.onSubmit("ddpi", {
      headerText:
        "There was some problem in raising service request. Please try again later.",
    });
  };

  /**
   * Error Popup For Already SR Created
   */
  const openExistSrPopup = () => {
    props.setLoader(false);
    props.onSubmit("ddpi", {
      headerText: "You have an active service request",
      content:
        "You already have an active service request. Once it is updated, you will be able to raise new request.",
    });
  };

  /**
   * Validation on Ddpi Details
   * @param id Ddpi Id
   */
  const validation = async (id: any) => {
    props.setLoader(true);
    if (id !== "") {
      var ddpid = id;
      try {
        const validationRes = await DdpiValidation({
          dpId: ddpid,
          accTyp: LoginService.getAccData("accTyp"),
        });
        const validatedJson = validationRes;
        if (Object.keys(validatedJson).length !== 0) {
          if (validatedJson.hasOwnProperty("data")) {
            if (Object.keys(validatedJson).length !== 0) {
              const data = validatedJson.data;
              const result = JSON.parse(data.value).result[0];
              if (result.ValidationStatus === "Failed") {
                setValidationErrStatus(true);
                const validationRemarks = result["ValidationRemarks"];
                const finalErrMsg = validationRemarks.map((val: any) => {
                  return val["validation_message"];
                });
                let validationMsg;
                if (validationRemarks) {
                  validationMsg = (
                    <p className="help-text red">{finalErrMsg.join(", ")}</p>
                  );
                  // validationMsg = validationRemarks.map((val: any)  => {
                  //   return (<li className="errlist">
                  //     <p className="help-text red">
                  //     <span>{val['validation_message']}</span>
                  //     </p>
                  //   </li>)
                  // });
                  setValidationErr(validationMsg);
                }
              }
            }
          }

          props.setLoader(false);
        }
      } catch (error) {
        openDDPIErrorPopup();
      }
    } else {
      props.setLoader(false);
    }
  };

  /**
   * Call On ProceedToEssign Button click
   */
  const submitDetails = async () => {
    props.setParLoader(true);
    try {
      if (ddpiDetailsErrStatus || validationErrStatus) {
        props.setParLoader(false);
        (
          document.getElementsByClassName("modal-Sr")[0] as HTMLDivElement
        ).scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
        return;
      } else {
        //if (ddpiDetails.length > 0) {
        //const ddpiFlagValue = ddpiFlags.split("").join(",");
        const ddpiFlagValue = "S,P,M,T";
        const selectedDdpiInfo: any = ddpiDetails;
        // let selectedDdpiInfo = selectedDdpiInfo1.find((obj) => {
        //   return obj["BOID"] === ddpiId;
        // });
        const dpType = ddpiId.includes("IN") ? "NSDL" : "CDSL";
        //if (selectedDdpiInfo) {
        let reqObj = {
          acTyp: LoginService.getAccData("accTyp"),
          dpId: ddpiId,
          reqTyp: "demat",
          assignedTeamCode: 4,
          assignedTeamName: "Ops Helpdesk Team",
          callTypId: 18,
          subTypId: 890,
          clntTyp: "None",
          dpType: dpType,
          edit_id: 0,
          clientCategory: "Individual",
          address: {
            addr1: setAddressText(selectedDdpiInfo["AddressLine1"]),
            addr2: setAddressText(selectedDdpiInfo["AddressLine2"]),
            addr3: setAddressText(selectedDdpiInfo["AddressLine3"]),
            addr4: setAddressText(selectedDdpiInfo["AddressLine4"]),
            city: selectedDdpiInfo["City"],
            state: selectedDdpiInfo["State"],
            pin: selectedDdpiInfo["PinCode"],
          },
          ddpiFlag: ddpiFlagValue,
        };

        const resp: any = await createDdpiSR(reqObj);
        if (
          Object.keys(resp).length > 0 &&
          resp.hasOwnProperty("data") &&
          resp.data.srId
        ) {
          await proceedToEsign(resp);
        } else if (
          Object.keys(resp).length > 0 &&
          resp.hasOwnProperty("error") &&
          resp.error.errCd === "SR0005"
        ) {
          openExistSrPopup();
        } else {
          openDDPIErrorPopup();
        }
      }
    } catch (error: any) {
      openDDPIErrorPopup();
    }
  };

  /**
   * Call for proceed to esign
   */
  const proceedToEsign = async (data?: any) => {
    try {
      const esign = await getEsignUrlJMWV2("", data.data.srId, "ddpi");
      props.setParLoader(false);
      if (!esign) {
        openDDPIErrorPopup();
      }
    } catch (err) {
      openDDPIErrorPopup();
    }
  };

  /**
   * Get Pre-Filled Form
   */
  const getPreFilledFormPDF = async () => {
    try {
      const response = await getDDPIPreFilledFormPDF();
      if (!response) {
        openDDPIErrorPopup();
      } else {
        setPreFilledForm(response);
      }
    } catch (err) {
      openDDPIErrorPopup();
    }
  };

  const toCamelCase = (string: any) => {
    return string.replace(/\w\S*/g, function (txt: any) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  };

  /**
   * Call on Button Download POA Pre-filled Form Click
   */
  const downloadPreFilledForm = async () => {
    props.setParLoader(true);
    try {
      if (ddpiDetailsErrStatus || validationErrStatus) {
        props.setParLoader(false);
        (
          document.getElementsByClassName("modal-Sr")[0] as HTMLDivElement
        ).scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
        return;
      } else {
        const preFilledFormData = preFilledForm;
        if (
          Object.keys(preFilledFormData).length > 0 &&
          preFilledFormData.hasOwnProperty("data")
        ) {
          const data = preFilledFormData["data"];
          if (data.hasOwnProperty("data")) {
            const base64Str = data.data;

            base64toPDF(base64Str);
          } else {
            openDDPIErrorPopup();
          }
        } else {
          openDDPIErrorPopup();
        }
      }
    } catch (err) {
      openDDPIErrorPopup();
    } finally {
      props.setParLoader(false);
    }
  };

  /**
   * Set Ddpi text on button click showmore or showless
   */
  const showDdpiText = async () => {
    setShowTextStatus(!showTextStatus);
  };

  const setDdpiOptions = (event: any) => {
    if (event.target.checked) {
      setDdpiFlags(ddpiFlags.concat(event.target.name));
    } else {
      setDdpiFlags(ddpiFlags.replace(event.target.name, ""));
    }
  };

  const editSaveBtnAuthorization = () => {
    setEditSaveBtnStatus(!editSaveBtnStatus);
  };
   const isAccClouserOpen = serviceReqListArr?.length && serviceReqListArr.find((item:any) =>
    item.RequestType === 'Online Closure' && (item.RequestStatus === 'EsignSubmitted' || item.RequestStatus === 'Assigned' || item.RequestStatus === 'Open' || item.RequestStatus === 'PendingForEsign')
  );
  return (
    <>
      {props.loader ? null : (!isAccClouserOpen? 
      (<div className="ddpiWrap">
        {/* {loader && (
          <div
            style={{
              textAlign: "center",
              paddingTop: "50px",
              paddingBottom: "50px",
            }}
          >
            <Loader size={50} color="blue"></Loader>
          </div>
        )} */}
        {!props.loader && (
          <>
            {ddpiDetailsErrStatus ? (
              <ul className="errlistWrap">
                <span className="help-text red">{ddpiDetailsErrMessage}</span>
              </ul>
            ) : (
              ""
            )}

            <div>
              <h1 className="comp_tit">What is DDPI?</h1>
            </div>
            <p className="comp_txt">
              SEBI has introduced Demat Debit and Pledge instruction which will
              replace POA (Power of Attorney). DDPI is an authorization to access
              your demat account for the below mentioned specific purpose
            </p>
            {/* <div className="button icon-btn ">
              <button
                type="button"
                className="ed_button common_button linkBtn"
                onClick={(e: any) => {
                  showDdpiText();
                  e.preventDefault();
                }}
              >
                <span className="arrow_text">
                  View authorization list{" "}
                  {!showTextStatus ? (
                    <i className={"edel-icon-sort-2 arrow_icon"} />
                  ) : (
                    <i className={"edel-icon-sort-1 arrow_icon"} />
                  )}
                </span>
              </button>
            </div> */}
            {/* {!showTextStatus ? (
              <></>
            ) : ( */}
            <>
              <div className="addrBlock">
                <div className="addrBlock_section">
                  <ol>
                    <li>
                      {/* <Checkbox
                          checked={ddpiFlags.includes("S")}
                          name="S"
                          onChange={setDdpiOptions}
                          disabled={editSaveBtnStatus}
                        > */}
                      <span className="comp_txt">
                        For seamless payin of securities to exchange towards
                        settlement obligations. i.e., to sell your holdings
                        seamlessly.
                      </span>
                      {/* </Checkbox> */}
                    </li>
                    <li>
                      {/* <Checkbox
                          checked={ddpiFlags.includes("P")}
                          name="P"
                          onChange={setDdpiOptions}
                          disabled={editSaveBtnStatus}
                        > */}
                      <span className="comp_txt">
                        To pledge / repledge securities
                      </span>
                      {/* </Checkbox> */}
                    </li>
                    <li>
                      {/* <Checkbox
                          checked={ddpiFlags.includes("M")}
                          name="M"
                          onChange={setDdpiOptions}
                          disabled={editSaveBtnStatus}
                        > */}
                      <span className="comp_txt">
                        To settle MF transaction executed through stock exchange
                      </span>
                      {/* </Checkbox> */}
                    </li>
                    <li>
                      {/* <Checkbox
                          checked={ddpiFlags.includes("T")}
                          name="T"
                          onChange={setDdpiOptions}
                          disabled={editSaveBtnStatus}
                        > */}
                      <span className="comp_txt">
                        To tender shares in buyback
                      </span>
                      {/* </Checkbox> */}
                    </li>
                  </ol>
                </div>
                {/* {
                    <div className="button icon-btn">
                      <button
                        type="button"
                        className="ed_button common_button linkBtn"
                        onClick={(e: any) => {
                          editSaveBtnAuthorization();
                          e.preventDefault();
                        }}
                        disabled={!(ddpiFlags.length > 0)}
                      >
                        <span className={(ddpiFlags.length > 0)? ("arrow_text_enable"):("arrow_text_disable")}>
                          {editSaveBtnStatus
                            ? `Edit Authorization list`
                            : `Save Authorization list`}
                        </span>
                      </button>
                    </div>
                  } */}
                {/* {ddpiFlags.length !== 4 ? ( */}
                <div className="ddpi_flag_note">
                  <p className="help-text">
                    In case you wish to modify the DDPI subsequently, please
                    contact your servicing RM/nearest branch
                  </p>
                </div>
                {/* ) : ( */}
                {/* <></>
                  )} */}
                {/* <div>
                    <h1 className="comp_tit">DDPI Doesn't Support:</h1>
                    <p className="comp_txt">
                      Corporate Actions (Buyback, Takeover, Delisting, etc)
                    </p>
                    <p className="comp_txt">Mutual Fund Transactions</p>
                    <br></br>
                    <p className="comp_txt">
                      To execute any transactions DDPI doesn't support, we would require a prefilled POA to be sent on the below given address or the settlement would be done through E-DIS.
                    </p>
                  </div>
                  <br></br>
                  <span className="comp_txt">
                    <span className="comp_tit_address">Address: </span>
                    {toCamelCase("Nuvama Wealth and Investment Limited, C/O. ") + "SSAI, Casa " + toCamelCase("BLANCA, UNIT NO.")}
                    {toCamelCase(" -803-805, ")}
                    {toCamelCase("SECTOR 11, PLOT NO. 45, OPP. IDBI TOWERS, NR. ") + "CBD "}
                    {toCamelCase("BELAPUR STATION,")}
                    {"CBD " + toCamelCase("BELAPUR, PIN CODE: 400614")}
                  </span> */}
              </div>
            </>
            {/* )} */}

            <div className=" col hr_row">
              <hr className="slim_line"></hr>
            </div>
            <>
              {/* <div className=" col hr_row">
                <hr className="slim_line"></hr>
              </div> */}
              <div className="adharSecWrap">
                {/* <p className="text-center note">
                  <span>Please note: </span>
                  POAs will remain valid till you revoke the same. If you have not
                  submitted your POA, and do not wish to submit POA/DDPI. You can
                  still continue trading the way you currently do i.e through
                  e-DIS.
                </p> */}
                <div className="proceedEsign">
                  {/* <button
                    type="button"
                    className=" common_button login-btn block_btn"
                    onClick={(e: any) => {
                      submitDetails();
                      e.preventDefault();
                    }}
                    
                  disabled = {!(ddpiFlags.length > 0)}
                  >
                    Proceed to E-Sign DDPI Form
                  </button> */}
                  <EdButton
                    className="btn-padding common_button login-btn block_btn"
                    onClick={(e: any) => {
                      submitDetails();
                      e.preventDefault();
                    }}
                    value="Proceed to E-Sign DDPI Form"
                    btnTyp="primary"
                    disabled={!(ddpiFlags.length > 0)}
                  />
                </div>
                {/* <div className="button icon-btn">
                  <button
                    type="button"
                    className="ed_button common_button"
                    onClick={(e: any) => {
                      downloadPreFilledForm();
                    }}
                  >
                    <span className="edel-icon-download"></span>
                    <span>Download POA Pre-filled Form</span>
                  </button>
                </div> */}

                <div className="text">
                  <h4 className="reminderText">
                    If your mobile and Aadhar are not linked please contact your
                    RM Arvind Kathappan
                  </h4>
                  <h4 className="reminderText">
                    Or write to us on{" "}
                    <a
                      href="mailto:helpdesk@nuvama.com"
                      className="mail_link bold-text"
                    >
                      helpdesk@nuvama.com
                    </a>
                  </h4>
                </div>
              </div>
            </>
          </>
        )}
      </div>)
      :<p className="help-text red line-ht-standard">You have an ongoing account closure request. During this time, you cannot initiate any request.</p>)}
    </>
  );
};
